import script from "./scanTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./scanTicket.vue?vue&type=script&setup=true&lang=js"

import "./scanTicket.vue?vue&type=style&index=0&id=0b24bc32&lang=css"

const __exports__ = script;

export default __exports__